import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

export default {
  consultas: (mes) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/consultasResumen/' + mes,
      method: 'post'
    })
  },
    exportConsultas: (mes) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/exportConsultas' ,
      method: 'post',
        body: mes
    })
  },
  meses: () => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getMesesConsultas',
      method: 'post'
    })
  }
}
